import { Icon } from '@app/components/core/icon/Icon'
import { Text } from '@app/components/core/typography/Text'
import Column from '@app/components/layout/Column'
import { ReactNode } from 'react'
import {
  faArrowRight,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TextLink } from '@app/components/core/link/TextLink'

export type MegaMenuItemProps = {
  to: string
  icon: IconDefinition
  label: string
  description?: string
  backgroundColor?: string
  children?: ReactNode
}

export const MegaMenuItem = ({
  to,
  icon,
  label,
  description,
  backgroundColor,
  children,
}: MegaMenuItemProps) => (
  <Column
    gap="1rem"
    style={{
      justifyContent: 'space-between',
    }}
  >
    <TextLink
      to={to}
      textStyle={{ display: 'flex', gap: '1rem' }}
      containerStyle={{
        '&:hover': {
          backgroundColor: 'var(--gray-100)',
          borderRadius: '0.5rem',
          transition: 'background-color 0.2s ease-in-out',
          '& .fa-arrow-right': {
            marginLeft: '0.5rem',
            transition: 'margin-left 0.2s ease-in-out',
          },
        },
        padding: '1rem',
        textDecoration: 'none',
      }}
    >
      <Icon
        icon={icon}
        size="small"
        style={{
          backgroundColor,
        }}
      />
      <Column gap="0.25rem">
        <Text.Large isBold>
          {label} <FontAwesomeIcon icon={faArrowRight} />
        </Text.Large>
        {description && (
          <Text.Medium color="var(--palette-blue-400)">
            {description}
          </Text.Medium>
        )}
      </Column>
    </TextLink>

    {children}
  </Column>
)

export type MegaMenuGridProps = {
  columns: {
    items: MegaMenuItemProps[]
  }[]
}

export const MegaMenuGrid = ({ columns }: MegaMenuGridProps) => (
  <>
    {columns.map((column, colIndex) => (
      <Column
        key={colIndex}
        gap="2rem"
        style={{ justifyContent: 'flex-start', width: '50%', flex: 1 }}
      >
        {column.items.map((item, itemIndex) => (
          <MegaMenuItem key={itemIndex} {...item} />
        ))}
      </Column>
    ))}
  </>
)
